
import React from "react";

export function EmptyPromptFeed() {
  return (
    <div className="text-center py-12 border border-border rounded-lg bg-card p-8 mt-6">
      <h3 className="text-lg font-medium">No prompts found</h3>
      <p className="text-muted-foreground mt-2">
        Try selecting a different category or check back later!
      </p>
    </div>
  );
}
